import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=a3399d7e&"
import script from "./OrganizationManage.vue?vue&type=script&lang=js&"
export * from "./OrganizationManage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports